import { FC } from "react"
import {
  RateTableConfigDetails,
  RateflowCta
} from "../../../../../../../../types"

interface Props {
  values: RateTableConfigDetails
  setDetailsField: (field: string, value: any) => void
}

interface FieldProps {
  label: string
  children: React.ReactNode
}

const FieldRow: FC<FieldProps> = ({ label, children }) => (
  <div>
    <label className="block text-sm font-medium text-gray-600 mb-1">
      {label}
    </label>
    {children}
  </div>
)

const inputCls =
  "w-full px-3 py-2 text-sm bg-gray-50 border border-gray-200 rounded-md text-gray-700 focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500"

const RateTableCta: FC<Props> = ({ values, setDetailsField }) => {
  const cta: RateflowCta = values.details.rateflow_cta ?? {
    header: "",
    subHeader: "",
    button: ""
  }

  const setCta = (field: keyof RateflowCta, value: string) => {
    setDetailsField("rateflow_cta", { ...cta, [field]: value })
  }

  return (
    <div className="space-y-8 pt-2">
      <section>
        <h3 className="text-sm font-semibold text-gray-700 mb-1">
          Rateflow CTA
        </h3>
        <p className="text-xs text-gray-400 mb-4">
          Copy shown on the personalised rates call-to-action
        </p>

        <div className="space-y-4">
          <FieldRow label="Header">
            <input
              type="text"
              value={cta.header}
              onChange={e => setCta("header", e.target.value)}
              placeholder="Want more personalized rates?"
              className={inputCls}
            />
          </FieldRow>

          <FieldRow label="Sub-header">
            <input
              type="text"
              value={cta.subHeader}
              onChange={e => setCta("subHeader", e.target.value)}
              placeholder="Get customized rates tailored to your needs."
              className={inputCls}
            />
          </FieldRow>

          <FieldRow label="Button label">
            <input
              type="text"
              value={cta.button}
              onChange={e => setCta("button", e.target.value)}
              placeholder="Personalize My Rate"
              className={inputCls}
            />
          </FieldRow>
        </div>
      </section>
    </div>
  )
}

export default RateTableCta
